import { api } from '../utils/axios';
import { USER_ID } from "../constants/Constants";

export const getUser = () => async (dispatch) => {
  
  let data = {};
  data.target_user = { "user_id": USER_ID };

  dispatch({
    type: "GET_USER_REQUESTED"
  });
  try {
    const response = await api.post('get_user', data);
    dispatch({
      type: "GET_USER_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USER_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getUserAttributes = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_USER_ATTRIBUTES_REQUESTED"
  });
  try {
    const response = await api.post('get_user_attributes', data);
    dispatch({
      type: "GET_USER_ATTRIBUTES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USER_ATTRIBUTES_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateUserAttribute = (target_user_attributes) => async (dispatch) => {
  
  let data = {};
  data.target_user_attributes = target_user_attributes;

  dispatch({
    type: "UPDATE_USER_ATTRIBUTES_REQUESTED"
  });
  try {
    const response = await api.post('update_user_attribute', data);
    dispatch({
      type: "UPDATE_USER_ATTRIBUTES_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_USER_ATTRIBUTES_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const setUserPassword = (password) => async (dispatch) => {
  
  let data = {};
  data.current_password = password.password,
    data.new_password = password.confirmPassword;
  data.set_two_factor = password.set_two_factor;

  dispatch({
    type: "SET_USER_PASSWORD_REQUESTED"
  });
  try {
    const response = await api.post('set_password', data);
    dispatch({
      type: "SET_USER_PASSWORD_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "SET_USER_PASSWORD_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getUserUsageDump = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_USAGE_DUMP_REQUESTED"
  });
  try {
    const response = await api.post('get_usage_details', data);
    dispatch({
      type: "GET_USAGE_DUMP_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USAGE_DUMP_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getUserUsageSummary = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_USAGE_SUMMARY_REQUESTED"
  });
  try {
    const response = await api.post('get_usage_summary', data);
    dispatch({
      type: "GET_USAGE_SUMMARY_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USAGE_SUMMARY_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getSubscriptionInfo = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_SUBSCRIPTION_INFO_REQUESTED"
  });
  try {
    const response = await api.post('subscription_info', data);
    dispatch({
      type: "GET_SUBSCRIPTION_INFO_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_SUBSCRIPTION_INFO_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const cancelSubscription = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "CANCEL_SUBSCRIPTION_REQUESTED"
  });
  try {
    const response = await api.post('cancel_subscription', data);
    dispatch({
      type: "CANCEL_SUBSCRIPTION_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CANCEL_SUBSCRIPTION_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getAllProducts = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_PRODUCTS_REQUESTED"
  });
  try {
    const response = await api.post('subscriptions/getProducts', data);
    dispatch({
      type: "GET_PRODUCTS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_PRODUCTS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateSubscription = (planData) => async (dispatch) => {
  
  let data = planData;

  dispatch({
    type: "UPDATE_SUBSCRIPTION_REQUESTED"
  });
  try {
    const response = await api.post('update_subscription', data);
    dispatch({
      type: "UPDATE_SUBSCRIPTION_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_SUBSCRIPTION_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updatePayment = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "UPDATE_PAYMENT_REQUESTED"
  });
  try {
    const response = await api.post('update_payment', data);
    dispatch({
      type: "UPDATE_PAYMENT_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_PAYMENT_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const renewSubscription = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "RENEW_SUBSCRIPTION_REQUESTED"
  });
  try {
    const response = await api.post('renew_subscription', data);
    dispatch({
      type: "RENEW_SUBSCRIPTION_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "RENEW_SUBSCRIPTION_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createSubscription = (planData) => async (dispatch) => {
  
  let data = planData;

  dispatch({
    type: "CREATE_SUBSCRIPTION_REQUESTED"
  });
  try {
    const response = await api.post('create_subscription', data);
    dispatch({
      type: "CREATE_SUBSCRIPTION_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_SUBSCRIPTION_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}
export function setUsagePageInfo({ pageSize, pageNo }) {
  return {
    type: 'SET_USAGE_PAGEINFO',
    payload: { pageSize, pageNo }
  }
}
export function setAdminUsagePageInfo({ pageSize, pageNo }) {
  return {
    type: 'SET_ADMIN_USAGE_PAGEINFO',
    payload: { pageSize, pageNo }
  }
}
export function setUserProfilePageInfo({ pageSize, pageNo }) {
  return {
    type: 'SET_USER_PROFILE_PAGEINFO',
    payload: { pageSize, pageNo }
  }
}